// extracted by mini-css-extract-plugin
module.exports = {"container":"newBusinessInsightsMenu_container__2_g44","insightsList":"newBusinessInsightsMenu_insightsList__3yBdw","active":"newBusinessInsightsMenu_active__ehMx7"};